import { z } from "zod";

export const Vote = z.object({
  has_been_voted: z.boolean(),
  votes_number: z.number(),
});

export type Vote = z.infer<typeof Vote>;
